export default {"src":"/_next/static/media/mlp-header-logo.75bbeda6.svg","height":16,"width":94,"blurWidth":0,"blurHeight":0};